<script lang="ts" setup>
  import { onMounted, useTemplateRef } from 'vue';
  import { InputField } from '../../../../shared/ui/input-field';

  defineProps<{ placeholder: string; disabled?: boolean; error?: string }>();
  const model = defineModel<string>();

  const inputRef = useTemplateRef<HTMLInputElement>('input');

  const showKeyboardWhereSupported = () => navigator.virtualKeyboard?.show();

  onMounted(() => {
    inputRef.value?.focus();
    showKeyboardWhereSupported();
  });
</script>

<template>
  <search>
    <InputField v-slot="field" :error>
      <input
        ref="input"
        v-model="model"
        v-bind="field"
        :disabled="disabled"
        :placeholder="$props.placeholder"
        aria-label="Song"
        enterkeyhint="search"
        type="search"
        virtualkeyboardpolicy="manual"
        @click="showKeyboardWhereSupported"
      />
    </InputField>
  </search>
</template>

<style scoped>
  search {
    display: flex;
    justify-content: center;
    width: 100%;
  }

  input {
    appearance: none;
    background: var(--color-surface);
    border: 2px solid var(--color-border-strong);
    border-radius: var(--radius-control);
    box-shadow: 0 2px 4px var(--color-shadow-faint);
    font: inherit;
    font-size: var(--font-size-lg);
    height: 3.5rem;
    max-width: var(--control-max-width);
    outline: none;
    text-align: center;
    transition: all 0.2s ease-in-out;
    width: 100%;
  }

  input:focus {
    border-color: var(--color-primary);
    box-shadow: 0 4px 8px var(--color-shadow);
  }

  input[aria-invalid='true'] {
    border-color: var(--color-error);
  }
</style>
